import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import * as bootstrap from 'bootstrap';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { LoginComponent } from '../login/login.component';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { PopupRequest, PromptValue, RedirectRequest } from '@azure/msal-browser';
import { b2cPolicies } from 'src/app/config/auth-config';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-verification',
    templateUrl: './verification.component.html',
    styleUrls: ['./verification.component.scss'],
})
export class VerificationComponent {
    faGoogle = faGoogle;
    @ViewChild('signUpModal') signUpModal!: ElementRef; // Reference to the modal
    @ViewChild(LoginComponent) logInModalInstance!: LoginComponent;
    isUserVerified: boolean = false;
    apiCalling: boolean = true;
    msalGuardConfig: any;
    navigateToBaseURL() {
        const signUpSignInFlowRequest: RedirectRequest = {
            authority: b2cPolicies.authorities.signUpSignIn.authority,
            prompt: PromptValue.LOGIN, // force user to reauthenticate with their new password
            scopes: [],
            redirectUri: environment.appUrl,
            redirectStartPage: '/',
        };

        this.login(signUpSignInFlowRequest);
    }
    login(userFlowRequest?: RedirectRequest | PopupRequest) {
        // if (this.msalGuardConfig.authRequest) {
        //     this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest, ...userFlowRequest } as RedirectRequest);
        // } else {
        this.msalService.loginRedirect(userFlowRequest);
        //}
    }
    constructor(
        private authService: AuthService,
        private msalService: MsalService,
    ) {
        // this.clientUrlName = this.route.snapshot.params.clientUrlName;
        // this.userGroupName = this.route.snapshot.params.userGroupName;
    }
    openLogInModal() {}
    verifyToken: string = '';
    ngOnInit() {
        this.verifyToken = this.getverifyToken(window.location.href);
        this.apiCalling = true;
        this.verifyUser();
        // Access the LoginModalComponent after initialization
        // this.logInModalInstance = new LoginComponent();
    }
    getverifyToken(str: string) {
        return str.split('token=')[1];
    }
    verifyUser() {
        const data = {
            token: this.verifyToken,
        };
        this.authService.verifyUser(data).subscribe((response) => {
            if (response != undefined && response != null && response != '') {
                console.log('response');
                console.log(response);
                this.isUserVerified = response === 1;
                this.apiCalling = false;
                // const verifyTokenResponse: any = response;
                // this.isUserVerified = verifyTokenResponse.Valid == 'true' ? true : false;
                // this.loginToken = verifyTokenResponse.LT;
                // this.apiCalling = false;
                // this.spinner.hideSpinner();
            }
        });
    }
    openSignUpModal() {
        const modalElement = this.signUpModal.nativeElement;
        const modalInstance = new bootstrap.Modal(modalElement);

        modalInstance.show();
    }

    closeSignUpModal() {
        const modalElement = this.signUpModal.nativeElement;
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide(); // Call hide() on the existing modal instance if it exists
        }
    }
}
